module.exports = __webpack_public_path__ + "d2ed72f59de49f10a09c9f54dd74fa87.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-1024.jpg
// module id = 436
// module chunks = 0